export const PHOTO_UPLOAD_TELEMETRY_CATEGORY = 'widget.photoUpload';
